<script lang="ts">
    import {onMount} from "svelte";
    import {MessageStore} from "../../../store/MessageStore";
    import {ImagePathConfig} from "../../../ImagePathConfig";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import HttpRequestOption from "../../../lib/Common/Http/HttpRequestOption";

    const displayMilliSeconds = 3000;

    $: cornerMessage = MessageStore.cornerMessage;
    $: {
        // cornerMessage が変更された場合、表示を行う
        if ($cornerMessage != null) {
            isShow = true;
            doClosing = false;
            if (closingTimeoutId !== 0) {
                clearTimeout(closingTimeoutId);
            }
            closingTimeoutId = setTimeout(() => {
                doClosing = true;
                isShow = false;
            }, displayMilliSeconds);

        }
    }

    $: message = (() => {
        if ($cornerMessage == null) {
            return '';
        }
        const message = $cornerMessage.message;
        if (message == null) {
            return '';
        }
        return message;
    })();

    $: requestButton = (() => {
        console.log($cornerMessage);
        if ($cornerMessage == null) {
            return null;
        }
        return $cornerMessage.requestButton;
    })();

    onMount(() => {
    });

    let doClosing: boolean = false;
    let closingTimeoutId: number = 0;
    let isShow: boolean = false;


    function onTransitionEnd() {
        if (doClosing) {
            cornerMessage.set(null);
            doClosing = false;
        }
    }

    function onClickRequest() {
        // console.log(requestButton);

        const url = requestButton.url;
        const body = requestButton.body;
        const method = requestButton.method;
        const requestCallback = requestButton.requestCallback;
        // console.log({requestCallback});


        if (method === 'post') {
            const option = HttpRequestOption.createForPost();
            option.successMessageRequestCallback = requestCallback;
            HttpRequestUtil.postRequest(url, body, (response) => {
                requestCallback(response);
            }, option);


        } else if (method === 'delete') {
            const option = HttpRequestOption.createForDelete();
            option.successMessageRequestCallback = requestCallback;
            HttpRequestUtil.deleteRequest(url, body, (response) => {
                requestCallback(response, requestCallback);
            });
        }

        cornerMessage.set(null);
        doClosing = false;
    }


</script>


<div class="corner-message-view"
     class:show={isShow}
     on:transitionend={onTransitionEnd}
>

    <div class="corner-message-area">
        <img class="icon" alt="" src={ImagePathConfig.CornerMessage.icon}/>
        <span class="message">
            { message }
        </span>
        {#if requestButton != null}
            <span class="request-button" on:click={onClickRequest}>
                { requestButton.text }

            </span>
        {/if}
    </div>
</div>
<style lang="scss">
    .corner-message-view {
        position: fixed;
        bottom: 0;
        left: 0;
        margin-left: 12px;


        padding-bottom: 12px;

        transform: translateY(100%);
        transition-duration: 1s;

        z-index: var(--corner-message-view-z-index);

        &.show {
            transform: translateY(0%);

        }

        .corner-message-area {
            border-style: solid;
            border-width: 1px;
            border-radius: 8px;

            border-color: var(--bana-red-color);
            //background-color: #fff;
            background-color: var(--bana-orange-color);
            color: var(--bana-white-color);

            padding-top: 0.5em;
            padding-bottom: 0.5em;
            padding-left: 1em;
            padding-right: 1em;

            font-size: 24px;

            min-height: 1em;

            display: flex;
            align-items: center;
            gap: 0.5em;

            .icon {
                height: 1.5em;
            }

            .message {
                min-width: 3em;
            }

            .request-button {
                font-size: 0.5em;
                text-decoration: underline;
                cursor: pointer;
                margin-left: 60px;
            }
        }

    }
</style>